
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import Stack from '@mui/joy/Stack';

import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';

import { ListItemDecorator } from '@mui/joy';

import { ChatRoomType } from 'stores/chat_room_store';
import SidebarList from 'components/SidebarList';

import FancyIcon from 'components/FancyIcon';
import useRoles from 'hooks/useRoles';
// import useUserIdentity from 'hooks/useUserIdentity';
// import useTeam from 'hooks/useTeam';

const VARIANT = 'outlined';

const RoomListItem = observer(({room}:{room: ChatRoomType}) => {
    const navigate = useNavigate();
    const { uuid } = useParams<{uuid: string}>();

    return (
        <ListItem>
            <ListItemButton
                variant={room.uuid === uuid ?  VARIANT : undefined}
                color={room.uuid === uuid ? "primary" : undefined}
                onClick={
                    () => navigate(`/chat/${room.uuid}`)
                }>
                {room.name}
            </ListItemButton>
        </ListItem>
    );
});

const ChatSidebar = observer(({rooms}:{rooms: ChatRoomType[]}) => {

    const location = useLocation();
    const navigate = useNavigate();
    const { hasRole } = useRoles();
    // const { fetchMyTeam, getTeam, items } = useTeam();

    // // const { currentIdentity } = useUserIdentity();
    // // const [fetched, setFetched] = useState(false);
    // // const [teamName, setTeamName] = useState('');
    // // const [team, setTeam] = useState<TeamType|null>(getTeam(currentIdentity?.team));

    if(!rooms.length)
        return null;

    const newSelected = location.pathname.startsWith('/chat/new');
    const noneSelected = location.pathname == '/chat';

    return (
        <Stack>
            <SidebarList>
            <ListItem>
        <ListItemButton
                variant={noneSelected ?  VARIANT : undefined}
                color={noneSelected ? "primary" : undefined}
                onClick={
                    () => navigate("/chat")
                }>

                Chats
            </ListItemButton>
        </ListItem>

                {rooms.map((room) =>
                    <RoomListItem key={room.uuid} room={room} />
                )}
                {hasRole('manager') &&
                    <ListItem>
                        <ListItemButton

                            variant={newSelected ? VARIANT : undefined}
                            color={newSelected ? "primary" : undefined}
                            onClick={
                                () => navigate("/chat/new")
                            }>

                            New Chat
                            <ListItemDecorator>
                                <FancyIcon name="Add" />
                            </ListItemDecorator>
                        </ListItemButton>
                    </ListItem>
                }
            </SidebarList>
        </Stack>
    );
});
export default ChatSidebar;
